import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const Step2Dance = props => {
  if (props.currentStep !== 2) {
    return null;
  }

  return (
    <>
      <FormGroup>

      <Label for="username">Learning Location </Label>  <br/>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="learningmode1" name="lead_mode" value="home" onChange={props.handleChange}/>
      <label class="form-check-label">My Home</label>
      </div>
       <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="learningmode2" name="lead_mode" value="premises" onChange={props.handleChange}/>
      <label class="form-check-label">Teacher Premises</label>
      </div>
       <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="learningmode3" name="lead_mode" value="online" onChange={props.handleChange}/>
      <label class="form-check-label">Online</label>
      </div>
      <br/>
      { /* 
      <Label for="username">I prefer to work with </Label> <br/> 
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="ptype1" name="lead_premisestype" value="individual" onChange={props.handleChange}/>
      <label class="form-check-label">Individual Teacher</label>
      </div>
       <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="ptype2" name="lead_premisestype" value="institution" onChange={props.handleChange}/>
      <label class="form-check-label">Institutional Teacher</label>
      </div> */ }
      </FormGroup>
    </>
  );
};

export default Step2Dance;
